export default class Item {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
}
